export default "__VITE_ASSET__CjOsu1Ww__"